module.exports = __webpack_public_path__ + "img/1256780180.f48953ac.jpg";